import { useToast } from '@razorpay/blade/components';
import React, { useState } from 'react';
import PerquisitesBreakdown from '../components/PerquisitesBreakdown';
import PerquisitesModal from '../components/PerquisitesModal';
import DeleteModal from '../components/generics/DeleteModal';
import { PerquisitesFormData } from '../types';

const PerquisitesView = () => {
  const [isPerquisiteModalOpen, setIsPerquisiteModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedComponentId, setSelectedComponentId] = useState<string | null>(null);
  const toast = useToast();

  // Mock data - would come from API in real implementation
  const perquisitesData = [
    {
      id: '1',
      component: 'Rent-free Accommodation',
      amountPaidByEmployee: 200000,
      totalValue: 500000,
    },
    {
      id: '2',
      component: 'Interest-free Loan',
      amountPaidByEmployee: 250000,
      totalValue: 250000,
    },
    {
      id: '3',
      component: 'Stock Options',
      amountPaidByEmployee: 250000,
      totalValue: 250000,
    },
  ];

  const onDismiss = () => {
    setIsPerquisiteModalOpen(false);
    setSelectedComponentId(null);
  };

  const onDismissDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedComponentId(null);
  };

  const onDelete = () => {
    //TODO: Implement the delete logic
    toast.show({
      color: 'information',
      content: 'Perquisite deleted successfully',
      action: {
        text: 'View change in payslip',
        onClick: () => {
          //TODO: Implement the view change in payslip logic
        },
      },
    });
    setIsDeleteModalOpen(false);
    setSelectedComponentId(null);
  };

  const onSubmit = () => {
    //TODO: Implement the update logic
    toast.show({
      color: 'positive',
      content: selectedComponentId ? 'Perquisite updated successfully' : 'Perquisite added successfully',
      action: {
        text: 'View change in payslip',
        onClick: () => {
          //TODO: Implement the payslip view logic
        },
      },
    });
    setIsPerquisiteModalOpen(false);
    setSelectedComponentId(null);
  };

  // Determine the initial form data based on the selected component
  let initialFormData: PerquisitesFormData = {
    componentId: '',
    amountPaidByEmployee: 0,
    totalValue: 0
  };
  
  if (selectedComponentId) {
    // Find the perquisite by ID
    const selectedPerquisite = perquisitesData.find(item => item.id === selectedComponentId);
    
    // If found, use its data
    if (selectedPerquisite) {
      initialFormData = {
        componentId: selectedPerquisite.id,
        amountPaidByEmployee: selectedPerquisite.amountPaidByEmployee,
        totalValue: selectedPerquisite.totalValue,
      };
    } else {
      initialFormData.componentId = selectedComponentId;
    }
  }

  // Find the name of the component for the delete modal
  const selectedPerquisiteName = selectedComponentId 
    ? perquisitesData.find(p => p.id === selectedComponentId)?.component || 'Unknown'
    : 'Unknown';

  return (
    <>
      <PerquisitesBreakdown
        setSelectedComponentId={setSelectedComponentId}
        openPerquisiteModal={() => setIsPerquisiteModalOpen(true)}
        openDeleteModal={() => setIsDeleteModalOpen(true)}
        perquisitesData={perquisitesData}
      />
      <PerquisitesModal
        key={selectedComponentId || 'new'}
        initialFormData={initialFormData}
        isOpen={isPerquisiteModalOpen}
        onDismiss={onDismiss}
        onSubmit={onSubmit}
      />
      <DeleteModal
        componentName="Perquisite"
        description={`You are about to delete the perquisite '${selectedPerquisiteName}'`}
        descriptionOnAction="Please note any past payslip and salary register will not be effective only future salary register and employee payslip will change"
        isOpen={isDeleteModalOpen}
        onDismiss={onDismissDeleteModal}
        onSubmit={onDelete}
      />
    </>
  );
};

export default PerquisitesView;
